import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Contested } from '../../../../enums/contested.enum';
import { Material } from '../../../../enums/material.enum';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OkCancelDialogComponent } from '../../../dialogs/ok-cancel/ok-cancel-dialog.component';
import { Router } from '@angular/router';
import { AnalysisManager } from '../../../../managers/analysis.manager';
import { Fact } from 'src/app/models/ui/fact.model';
import { BaseComponent } from '../../../base.component';
import { switchMap, takeUntil } from 'rxjs/operators';
import { filter } from 'rxjs';
import { NotificationManager } from '../../../../managers/notification.manager';

@Component({
    selector: 'lex-facts',
    templateUrl: './facts.component.html',
    styleUrls: ['./facts.component.scss'],
    standalone: false
})
export class FactsComponent extends BaseComponent implements AfterViewInit {
	public facts: Fact[];
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild('fileUpload', { static: false }) fileInputElement: ElementRef;

	public columnsToDisplay = [
		'title',
		'dateStart',
		'dateEnd',
		'contested',
		'material',
		'delete'
	];

	public contested = Contested;
	public material = Material;
	public dataSource = new MatTableDataSource<Fact>();
	public timelineData: Fact[];
	public contestedList = Contested.All;
	public materialList = Material.All;
	public showTimeline = false;

	constructor(
		private matDialog: MatDialog,
		private router: Router,
		private analysisManager: AnalysisManager,
		private notificationManager: NotificationManager) {
		super();

		this.analysisManager.filteredFacts$.pipe(
			takeUntil(this.destroy$)
		).subscribe((factCollection) => {
			this.dataSource.data = factCollection?.items;
			this.facts = factCollection?.items;
			setTimeout(() => {
				this.dataSource.sort = this.sort;
			});
		});
		this.analysisManager.refreshFacts();
	}

	public ngAfterViewInit() {
		this.dataSource.sortingDataAccessor = (item, property) => {
			if (property === 'contested')
				return Contested.displayText(item.contested);
			if (property === 'material')
				return Material.displayText(item.material);
			return item[property];
		};
	}

	public toggleTimeline() {
		this.showTimeline = !this.showTimeline;
	}

	public addFact() {
		this.router.navigate(['/', 'analytics', 'facts-and-issues', 'fact', 'new']);
	}

	public editFact(fact: Fact) {
		this.router.navigate(['/', 'analytics', 'facts-and-issues', 'fact', fact.id]);
	}

	public deleteFact(factId: string) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.data = {
			title: `Delete Fact`,
			message: `This fact will be <strong>PERMANENTLY DELETED</strong>.
          <br/> This action cannot be undone.`
		};

		this.matDialog.open(OkCancelDialogComponent, dialogConfig).afterClosed().pipe(
			filter((okClicked) => okClicked),
			switchMap(() => this.analysisManager.deleteFact({ id: factId }))
		).subscribe(() => {
			this.analysisManager.refreshFacts();
			this.notificationManager.displaySnackBarMessage({ message: 'Fact deleted successfully.' });
		});
	}

	public export() {
		this.analysisManager.export('facts');
	}

	public exportPivot() {
		this.analysisManager.export('facts-pivot');
	}

	public import(event: Event): void {
		const file: File = (event.target as HTMLInputElement).files[0];
		if (file) {
			this.analysisManager.import('facts', file).subscribe({
				complete: () => {
					this.notificationManager.displaySnackBarMessage({ message: 'Facts imported successfully.' });
					this.analysisManager.refreshFacts();
				},
				error: () => {
					this.notificationManager.displaySnackBarMessage(
						{
							message: 'An error occurred while attempting to import facts. Please check the file format and try again.',
							ttl: 5000,
							type: 'error'
						});
					this.fileInputElement.nativeElement.value = '';
				}
			});
		} else {
			this.fileInputElement.nativeElement.value = '';
		}
	}
}
